module.exports = __webpack_public_path__ + "static/media/Sharing with Loved Ones the Reasons for Our Hope.53459da6.docx";